import { Component } from '@angular/core'

@Component({
  selector: 'se-po-highlight-label-docs',
  templateUrl: './highlight-label-docs.component.html',
  styleUrls: ['./highlight-label-docs.component.scss'],
  standalone: false,
})
export class HighlightLabelDocsComponent {
  public html = `<div>
  <se-po-highlight-label
    label="This is a label for My Child"
    theme="child">
  </se-po-highlight-label>
</div>
<div style="margin-top: 24px;">
  <se-po-highlight-label
    label="This is a label for Myself or another adult"
    theme="adult">
  </se-po-highlight-label>
</div>`
}
